import { useContext, useEffect, useMemo, useRef, useState } from "react";
import timesheet from "../../../pages/Features/Timesheet/Timesheet.module.css";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { ToastContext } from "../../../context/ToastContext";
import { dateConvert, dateHoverRange, formatDateObject } from "../../../utils/Helper";
import { useLocation } from "react-router-dom";

export const useTimesheet = () => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [filterValues, setFilterValues] = useState({});
    const [loader, setLoader] = useState(false);
    const [detailsPopup, setDetailsPopup] = useState({ visible: false, userName: "", tableData: [], punchData: [], workLogDate: "", workHours: "" })
    const [rowDatas, setRowData] = useState([]);
    const [timesheetOptions, setTimesheetOptions] = useState("details");
    const [timeSheetOpen, setTimeSheetOpen] = useState(false);
    const [visible, setVisible] = useState(false);
    const [excelLoader, setExcelLoader] = useState(false);
    const [managerTimesheetData, setManagerTimesheetData] = useState([])
    const [viewGroup, setViewGroup] = useState(false);
    const [columnDefs, setColumnDefs] = useState([
        {
            field: "group_name",
            headerName: "Group Name",
            rowGroup: viewGroup,
            hide: true,
            width: 200,
        },
        {
            field: "user_email",
            headerName: "Users",
            suppressHeaderMenuButton: true,
            pinned: "left",
            width: 100,
        },
    ]);
    const [userData] = useState([]);
    const tagRef = useRef(null);
    const [columns] = useState([
        { field: "day_date", header: "Date" },
        { field: "project_name", header: "Project Name" },
        { field: "client_name", header: "Client Name" },
        { field: "project_module_name", header: "Project Module" },
        { field: "key", header: "Key" },
        { field: "issue", header: "Issue Type" },
        { field: "comment", header: "Comment" },
        { field: "log_time", header: "log Time", width: 8 },
        { field: "time_spent", header: "Time Spent" },
    ]);
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
    const [invoiceDates] = useState({});
    const currMonthOrder = useRef(null);
    const [monthOrder, setMonthOrder] = useState(null);
    const location = useLocation().state;

    // set columns dynamically when date changed
    const getColumnDefs = () => {
        if (filterValues?.date && filterValues?.date?.[0] !== undefined && filterValues?.date?.[1] !== undefined) {
            setColumnDefs([
                {
                    field: "group_name",
                    headerName: "Group Name",
                    rowGroup: viewGroup,
                    hide: true,
                    width: 200,
                },
                {
                    field: "user_email",
                    headerName: "Users",
                    suppressHeaderMenuButton: true,
                    pinned: "left",
                    width: 130,
                    cellRenderer: function (params) {
                        return (
                            <div style={{ cursor: "pointer" }}>
                                {params?.data?.user_email}
                            </div>
                        );
                    },
                },
            ]);

            const start = filterValues?.date?.[0];
            const end = filterValues?.date?.[1];
            const columnNames = [];
            const currentDate = new Date(start);

            let endDate = new Date(end);

            while (currentDate <= endDate) {
                const formattedDate = dateConvert(currentDate, "iso-string").split("T")[0];
                columnNames.push(formattedDate);
                currentDate.setDate(currentDate.getDate() + 1);
            }
            const isTotalRow = (params) => params.data.user_email === "Total";

            columnNames?.forEach((col) => {
                const dateObj = new Date(col);
                const dayHeader = dateObj?.toLocaleDateString("en-US", { day: "numeric" });
                const monthHeader = dateObj?.toLocaleDateString("en-US", { month: "short" });
                const weekDay = dateObj?.toString().slice(0, 3);
                const formattedMonth = monthHeader?.length > 3 ? monthHeader?.slice(0, 3) : monthHeader;

                const progressBarWidth = (param) => {
                    if (param >= 1 && param <= 9) {
                        return `${param * 10}%`;
                    } else {
                        return "0%";
                    }
                };
                let columnObject = {
                    headerName: `${formattedMonth}\n${dayHeader}\n${weekDay}`,
                    field: col,
                    width: 50,
                    headerClass: `header-wrap ${weekDay === "Sun" ? "sunday" : ""}`,
                    suppressHeaderMenuButton: true,
                    cellRenderer: function (params) {
                        const width = progressBarWidth(params.value);
                        if (!params.data) return "";
                        if (isTotalRow(params)) return Number(params.value);
                        const main_total = Number(params.data.main_total);
                        const param = Number(params.value);
                        if (param === main_total) {
                            return <div className={`${timesheet["params"]}`}>{Number(params.value)}</div>
                        } else if (param < main_total && params.value !== "00.00") {
                            return (
                                <div disabled={true} className={`${timesheet["params"]}`}>
                                    {Number(params.value)}
                                    <div className="progress" style={{ height: "2px", margin: "0px 2px 2px", backgroundColor: "transparent", border: "1px solid #ffa500" }} >
                                        <div className="progress-bar" role="progressbar" style={{ width: `${width}`, backgroundColor: "#ffa500" }} />
                                    </div>
                                </div>
                            );
                        } else if (param > main_total && params.value !== "00.00") {
                            return (
                                <div disabled={true} className={`${timesheet["params"]}`}>
                                    {Number(params.value)}
                                    <div className="progress" style={{ height: "3px", margin: "0px 2px 2px", backgroundColor: "transparent", border: "1px solid #FF2C2C" }} >
                                        <div className="progress-bar" role="progressbar" style={{ width: "100%", backgroundColor: "#FF2C2C" }} />
                                    </div>
                                </div>
                            );
                        } else if (param === 0 && params.data.holiday[col] == true) {
                            return <div className="timesheet-holiday-cell"></div>
                        } else if (param === 0) {
                            return (
                                <div disabled={true} className={`${timesheet["params"]}`}>
                                    {Number(params.value)}
                                    <div className="progress" style={{ height: "2px", margin: "0px 2px 2px", backgroundColor: "transparent", border: "1px solid #FFA500" }}>
                                        <div className="progress-bar" role="progressbar" style={{ width: "0%" }} />
                                    </div>
                                </div>
                            );
                        }
                    },
                };
                setColumnDefs((prev) => [...prev, columnObject]);
            });

            let totObj = {
                headerName: "Total",
                field: "total",
                width: 60,
                pinned: "left",
                headerClass: "header-wrap",
                suppressHeaderMenuButton: true,
                cellRenderer: function (params) {
                    if (!params.data) return "";
                    if (params.data.user_email === "Total") return Number(params.value);
                    return (
                        <div disabled={true} className={`${timesheet["params"]}`}>
                            {Number(params.value || 0)}
                            <div className="progress" style={{ height: "2px", margin: "0px 2px 2px", backgroundColor: "transparent", outline: "1px solid #ccc", }}>
                                <div className="progress-bar" role="progressbar" style={{ width: Number(params.value) === 0 ? "0" : "100%", backgroundColor: "#008000" }} />
                            </div>
                        </div>
                    );
                },
            };
            setColumnDefs((prev) => [...prev, totObj]);
        }
    };

    useEffect(() => {
        callautopopulate("user_info").then((res) => {
            setViewGroup(res?.user_info?.[0]?.is_user_grouping_view);
        })
        getInvoiceCalendar();
    }, []);

    useEffect(() => {
        if (location?.team !== timesheetOptions) {
            setTimesheetOptions(location?.team || "details");
            setFilterValues((prev) => ({ ...prev, apiCall: true }));
        }
    }, [location?.team])

    useEffect(() => {
        if (timesheetOptions === "details" && filterValues?.apiCall && filterValues?.date?.[0] && filterValues?.date?.[1]) {
            getColumnDefs();
            getStorageCustomEntity();
            setFilterValues((prev) => ({ ...prev, apiCall: false, isChange: false }));
        }
    }, [filterValues?.apiCall, filterValues?.date]);

    useEffect(() => {
        getColumnDefs();
    }, [viewGroup])

    useEffect(() => {
        if (!_.isEmpty(rowDatas)) {
            calculateTotals(rowDatas);
        }
    }, [columnDefs, rowDatas]);

    // get invoice dates for default selection
    const getInvoiceCalendar = async () => {
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETINVOICECALENDAR"));
            if (res) {
                const invoiceData = res?.body?.data?.invoice_Calendar;
                if (_.isEmpty(_.findWhere(invoiceData, { is_active: 1 }))) {
                    showError("error", "No active dates found");
                    return;
                }
                invoiceData?.forEach((data) => {
                    if (data?.is_active == 1) {
                        setMonthOrder(data?.month_order);
                        currMonthOrder.current = data?.month_order;
                        const startdate = data?.startdate?.split("T")?.[0];
                        const enddate = data?.end_date?.split("T")?.[0];
                        setFilterValues((prev) => ({ ...prev, date: [startdate, enddate] }))
                    }
                    if (_.isEmpty(_.findWhere(invoiceDates, { month_order: data?.month_order }))) {
                        invoiceDates[data?.month_order] = {
                            startdate: data?.startdate?.split("T")?.[0],
                            enddate: data?.end_date?.split("T")?.[0],
                            month_order: data?.month_order,
                        };
                    }
                });
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    };

    // set total row 
    const calculateTotals = (data) => {
        const totals = {};
        data?.forEach((row) => {
            columnDefs?.forEach((col) => {
                if (col.field !== "user_email") {
                    totals[col.field] = _.isNaN((totals[col.field] || 0) + Number(row[col.field] || 0)) ? 0 : (totals[col.field] || 0) + Number(row[col.field] || 0);
                }
            });
        });

        const totalRow = { user_email: "Total" };

        Object.keys(totals)?.forEach((key) => {
            totalRow[key] = _.isNaN(totals[key].toFixed(2)) ? 0 : totals[key].toFixed(2);
        });
        setPinnedBottomRowData([totalRow]);
    };

    // get timesheet data
    const getStorageCustomEntity = async () => {
        setRowData([]);
        const start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";
        const end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";
        const payload = {
            from_date: start || "",
            to_date: end || "",
            projects: _.pluck(filterValues?.projects, "project_id").toString() || "",
            users: _.pluck(filterValues?.users, "user_code").toString() || "",
            issueTypes: _.pluck(filterValues?.issue_type, "issue_type_id").toString() || "",
            project_lead_user_code: _.pluck(filterValues?.project_leads, "user_code").toString(),
        };

        try {
            setLoader(true);
            const res = await services.getInvokeRemote("POST", Urls("GETTIMESHEETSUMMARY"), payload);
            if (res?.body?.data) {
                const data = res.body.data.timesheet_Summary;
                const totalData = res.body.data.timesheet_Summary_Total;
                const userData = [];
                if (!_.isEmpty(data)) {
                    data.forEach((res) => {
                        let obj = {
                            user_email: res.user_display_name,
                            group_name: res.group_name,
                        };
                        obj[res.startedat] = res.loginfo;
                        obj["main_total"] = res.day_working_hours;
                        obj["user_code"] = res.user_code;
                        obj["is_holiday"] = res.is_holiday;

                        const findData = _.findWhere(totalData, { user_display_name: res.user_display_name });
                        if (!_.isEmpty(findData)) {
                            obj["total"] = findData.loginfo;
                            obj["bottom_main_total"] = findData.day_working_hours;
                        } else {
                            obj["total"] = 0;
                            obj["bottom_main_total"] = res.day_working_hours;
                        }

                        if (!_.find(userData, obj)) {
                            userData.push(obj);
                        }
                    });
                }
                setRowData(combineUserData(userData));
                await callautopopulate("user_info")?.then(res => {
                    setViewGroup(res?.user_info?.[0]?.is_user_grouping_view || false);
                })
            } else {
                console.error("Error retrieving data:");
            }
        } catch (error) {
            console.error("Error invoking getStorageFiltered:", error);
        } finally {
            setLoader(false);
        }
    };

    // format API data
    const combineUserData = (arr) => {
        return arr.reduce((acc, val, ind) => {
            const index = acc.findIndex(
                (el) =>
                    el.user_email === val.user_email && el.group_name === val.group_name
            );
            if (index !== -1) {
                const key = Object.keys(val)[2];
                acc[index][key] = val[key];
                acc[index]["holiday"] = {
                    ...acc[index]["holiday"],
                    [key]: val["is_holiday"],
                };
            } else {
                const key = Object.keys(val)[2];
                acc.push(val);
                const index = _.indexOf(acc, val);
                acc[index]["holiday"] = { [key]: val["is_holiday"] };
            }

            const sortedData = acc.sort((a, b) => { return a?.[viewGroup ? "group_name" : "user_display_name"]?.localeCompare(b?.[viewGroup ? "group_name" : "user_display_name"]) || a.user_email?.localeCompare(b.user_email) });
            // return _.sortBy(acc, "user_email");
            return sortedData;
        }, []);
    };

    const handleDateChange = async () => {
        getColumnDefs()
        setMonthOrder(0);
    };

    // get timesheet logs details
    const onCellClicked = async (event) => {
        if (event?.data?.holiday?.[event?.column?.colId] && Number(event?.value) === 0) {
            setDetailsPopup((prev) => ({ ...prev, visible: false }))
        } else if (event?.data && event?.column?.colId !== "total") {
            setDetailsPopup((prev) => ({ ...prev, userName: event?.data?.user_email }));
            if (event?.column?.colId !== "user_email") {
                setDetailsPopup((prev) => ({
                    ...prev, workHours: event.value, workLogDate: dateConvert(new Date(event?.colDef?.field), "day-mon-year")
                }))
            } else {
                setDetailsPopup((prev) => ({ ...prev, workLogDate: "", workHours: event?.data?.total }))
            }
            setDetailsPopup(((prev) => ({ ...prev, tableData: [], punchData: [] })));
            if (event.data.accountId !== null && event?.data?.user_email !== "Total") {
                let payload;
                if (event?.colDef?.field === "user_email") {
                    payload = {
                        from_date: typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : formatDateObject(filterValues?.date?.[0]),
                        to_date: typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : formatDateObject(filterValues?.date?.[1]),
                        users: event.data?.user_code?.toString(),
                    };
                } else {
                    payload = {
                        from_date: event.colDef.field,
                        to_date: event.colDef.field,
                        users: event.data?.user_code?.toString(),
                    };
                }
                try {
                    const res = await services.getInvokeRemote("POST", Urls("GETTIMESHEETDETAILS"), payload);
                    
                    const punchPayload = {
                        project_lead_user_code: "",
                        from_date: payload.from_date,
                        to_date: payload.to_date,
                        users: payload.users,
                        log_in_out_type: "",
                        requested_shift_minutes: 0
                    };
                    const punchRes = await services.getInvokeRemote("POST", Urls("GETDAILYPUNCHINDETAILS"), punchPayload);
                    let punchData = [];
                    if (punchRes?.body?.data?.manager_attandance_details) {
                        punchData = punchRes.body.data.manager_attandance_details;
                    }

                    const data = res?.body?.data?.timesheet_Details || [];
                    const newData = _.sortBy(data, "day_date")?.map((log) => {
                        return {
                            day_date: dateConvert(log?.day_date),
                            project_name: log.project_name,
                            client_name: log.client_name,
                            key: log.issue_key,
                            issue: log.issue_type_name,
                            comment: log.comment,
                            time_spent: log.timeSpent,
                            issueUrl: log.issue_url,
                            log_time: log?.log_time,
                            project_module_name: log?.project_module_name
                        };
                    });
                    setDetailsPopup(((prev) => ({ ...prev, tableData: newData, punchData: punchData, visible: true })));
                } catch (error) {
                    console.error(error);
                }
            }
        }
    };

    // to download hR excel
    const getExcelDownload = async () => {
        const start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";
        const end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";
        if (!start || !end) {
            showInfo("info", " Please Select Dates")
            return;
        }
        setExcelLoader(true);
        const payload = {
            from_date: start || "",
            to_date: end || "",
            projects: _.pluck(filterValues?.projects, "project_id").toString() || "",
            users: _.pluck(filterValues?.users, "user_code").toString() || "",
            issueTypes: _.pluck(filterValues?.issue_type, "issue_type_id").toString() || "",
            project_lead_user_code: _.pluck(filterValues?.project_leads, "user_code").toString(),
        };
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETMANAGERTIMESHEETEXCELDETAILS'), payload);
            if (res?.body?.data) {
                const formatKey = key =>
                    key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                const formattedData = res?.body?.data?.manager_Timesheet_Summary.map(obj => {
                    const newObj = {};
                    Object.keys(obj).forEach(key => {
                        newObj[formatKey(key)] = obj[key];
                    });
                    return newObj;
                });
                const worksheet = XLSX.utils.json_to_sheet(formattedData); //JSON to sheet
                worksheet['!cols'] = formattedData.length > 0
                    ? Object.keys(formattedData[0]).map(() => ({ wch: 20 })) // set 20-char width per column
                    : [];
                const workbook = XLSX.utils.book_new(); // Create a workbook
                XLSX.utils.book_append_sheet(workbook, worksheet, "Timesheets");  // Add sheet to workbook
                const file = `HR_timesheet_${start}_to_${end}.xlsx`
                XLSX.writeFile(workbook, file);
            } else {
                showError("Error", res.body.errorMessage)
            }
            setExcelLoader(false)
        } catch (error) {
            setExcelLoader(false)
            showError("Error", error?.response?.data?.errorMessage);
            console.error(error);
        }
    };

    // // to download manager excel 
    const getManagerExcelDownload = () => {
        if (_.isEmpty(managerTimesheetData)) {
            showInfo("Info", "There is no data to download");
            return;
        }
        const fixedFields = ["manager", "member_name", "working_hours", "pending_hours", "total"];
        const headerMap = {
            manager: "Manager Name",
            member_name: "Member Name",
            working_hours: "Working Hours",
            pending_hours: "Pending Hours",
            total: "Total Hours",
        };
        const dynamicFieldGroups = {};
        const dynamicFieldNames = {};

        managerTimesheetData.forEach(({ issue_type_groups = {} }) => {
            Object.entries(issue_type_groups).forEach(([groupName, issues]) => {
                issues.forEach(({ issue_type_id, issue_type_name }) => {
                    dynamicFieldGroups[issue_type_id] = groupName;
                    dynamicFieldNames[issue_type_id] = issue_type_name;
                });
            });
        });
        const dynamicFieldsSet = new Set();
        managerTimesheetData.forEach((entry) => {
            Object.keys(entry).forEach((key) => {
                if (
                    !fixedFields.includes(key) &&
                    !key.includes("user_code") &&
                    dynamicFieldGroups[key] !== undefined
                ) {
                    dynamicFieldsSet.add(key);
                }
            });
        });

        const dynamicFields = Array.from(dynamicFieldsSet).sort((a, b) =>
            (dynamicFieldNames[a] || "").toLowerCase().localeCompare((dynamicFieldNames[b] || "").toLowerCase())
        );
        const allFields = [...fixedFields, ...dynamicFields];
        const firstHeaderRow = fixedFields.map(() => "");
        let currentGroup = null;
        dynamicFields.forEach((field) => {
            const groupName = dynamicFieldGroups[field] || "Other";
            if (groupName !== currentGroup) {
                firstHeaderRow.push(groupName);
                currentGroup = groupName;
            } else {
                firstHeaderRow.push("");
            }
        });
        const secondHeaderRow = allFields.map((field) =>
            fixedFields.includes(field) ? headerMap[field] : dynamicFieldNames[field] || field
        );
        const dataRows = managerTimesheetData.map((row) =>
            allFields.map((field) => (row[field] ?? "").toString())
        );
        const sheetData = [firstHeaderRow, secondHeaderRow, ...dataRows];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        worksheet["!merges"] = [];
        if (fixedFields.length > 1) {
            worksheet["!merges"].push({
                s: { r: 0, c: 0 },
                e: { r: 0, c: fixedFields.length - 1 },
            });
        }
        currentGroup = null;
        let groupStartIndex = fixedFields.length;

        dynamicFields.forEach((field, i) => {
            const groupName = dynamicFieldGroups[field] || "Other";
            if (groupName !== currentGroup) {
                if (currentGroup !== null && groupStartIndex < fixedFields.length + i - 1) {
                    worksheet["!merges"].push({
                        s: { r: 0, c: groupStartIndex },
                        e: { r: 0, c: fixedFields.length + i - 1 },
                    });
                }
                currentGroup = groupName;
                groupStartIndex = fixedFields.length + i;
            }
        });
        if (currentGroup !== null && groupStartIndex < fixedFields.length + dynamicFields.length - 1) {
            worksheet["!merges"].push({
                s: { r: 0, c: groupStartIndex },
                e: { r: 0, c: fixedFields.length + dynamicFields.length - 1 },
            });
        }
        const colWidths = sheetData[1].map((_, colIndex) =>
            sheetData.reduce(
                (max, row) => Math.max(max, (row[colIndex] || "").length + 2),
                10
            )
        );
        worksheet["!cols"] = colWidths.map((wch) => ({ wch }));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Manager Report");
        const start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";
        const end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";
        const file = `Manager_timesheet_${start}_to_${end}.xlsx`
        XLSX.writeFile(workbook, file);
    };


    const handleMonthChange = (mon) => {
        if (monthOrder !== 0 && mon === "next" && (monthOrder === currMonthOrder.current)) {
            showInfo("info", "No more next invoice dates found");
            // setMonthOrder(0);
            return;
        }
        const order = monthOrder !== 0 ? (mon === "prev" ? monthOrder - 1 : (mon === "curr" ? currMonthOrder.current : (mon === "next") ? (monthOrder + 1) : null)) : currMonthOrder.current;
        setMonthOrder(order);
        invoiceDates && setFilterValues((prev) => ({ ...prev, date: [invoiceDates?.[order]?.startdate, invoiceDates?.[order]?.enddate,], apiCall: true }));
    };

    // upsert pending timesheet data
    const upsertPendingTimesheet = async () => {
        if (filterValues?.date && filterValues?.date?.[0] !== undefined && filterValues?.date?.[1] !== undefined) {
            const start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";
            const end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";
            setLoader(true)
            const payload = {
                "from_date": start || "",
                "to_date": end || "",
            };
            try {
                const res = await services.getInvokeRemote('POST', Urls('UPSERTPENDINGTIMESHEET'), payload);
                if (res?.body?.data) {
                    showSuccess('Success', res.body.message)
                } else {
                    showError("Error", res.body.errorMessage)
                }
            } catch (error) {
                console.error(error);
            } finally {
                setVisible(false)
                setLoader(false)
            }
        } else {
            showInfo("Info", "Please Select Date.");
        }

    };

    const handleDownloadTimeSheet = async () => {
        if (_.isEmpty(detailsPopup?.tableData)) {
            showInfo("Info", "There is no data to download");
            return;
        }
        const groupedData = _.groupBy(detailsPopup?.tableData, row => row.day_date);
        const exportData = [];
        Object.entries(groupedData)
            .sort(([dateA], [dateB]) => new Date(dateA) - new Date(dateB))
            .forEach(([day_date, rows]) => {
                rows.forEach((row, idx) => {
                    const exportRow = columns.reduce((acc, col) => {
                        acc[col.header] = row[col.field];
                        return acc;
                    }, {});
                    exportRow["Date"] = idx === 0 ? day_date : "";
                    exportData.push(exportRow);
                });
            });
        const worksheet = XLSX.utils.json_to_sheet(exportData, { skipHeader: false });
        worksheet['!cols'] = columns.map(col => ({
            wch: col.width || 20
        }));
        worksheet['!cols'].push({ wch: 15 });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });

        const start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || "";
        const end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || "";
        saveAs(data, `${detailsPopup?.userName}_timesheet_${start}_to_${end}.xlsx`);
    };

    const getAllEmployeeTimesheetExcel = async () => {
        try {
            if (!filterValues?.date?.[0] && !filterValues?.date?.[1]) {
                showInfo("info", " Please Select Dates")
                return;
            }
            const start = (typeof filterValues?.date?.[0] === "string" ? filterValues?.date?.[0] : dateHoverRange(filterValues?.date?.[0])) || undefined;
            const end = (typeof filterValues?.date?.[1] === "string" ? filterValues?.date?.[1] : dateHoverRange(filterValues?.date?.[1])) || undefined;
            if (start === undefined || end === undefined) {
                showInfo("info", " Please Select Dates")
                return;
            }
            const payload = {
                from_date: start,
                to_date: end,
                users: _.uniq(_.pluck(rowDatas, "user_code")).toString(),
            };
            const res = await services?.getInvokeRemote("POST", Urls("GETTIMESHEETDETAILS"), payload);
            const logs = [...res?.body?.data?.timesheet_Details];

            logs.forEach(l => l.day_date = l.day_date ? new Date(l.day_date) : null);

            logs.sort((a, b) => {
                if (a.user_display_name === b.user_display_name) {
                    if (!a.day_date || !b.day_date) return 0;
                    if (a.day_date.getTime() === b.day_date.getTime()) {
                        if (a.log_datetime && b.log_datetime) return a.log_datetime.localeCompare(b.log_datetime);
                        return 0;
                    }
                    return a.day_date - b.day_date;
                }
                return a.user_display_name.localeCompare(b.user_display_name);
            });
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Worklogs");
            const headerRow = ["Name", "Date", "Project Name", "project_module_name", "Issue Key", "Issue Type", "Comment", "Log Time", "Time Spent"];

            worksheet.addRow(headerRow);
            worksheet.addRow([]);
            worksheet.getRow(1).font = { bold: true };
            worksheet.getRow(1).alignment = { vertical: "middle" };

            worksheet.getColumn(7).width = 100;
            worksheet.columns.forEach((col, idx) => {
                if (idx === 6) return;
                col.width = 25;
            });
            let dataStartRow = 3;
            let lastUser = null;
            let lastUserStartRow = dataStartRow;
            logs.forEach((l, i) => {
                const excelRow = [
                    l.user_display_name,
                    l.day_date ? l.day_date.toISOString().slice(0, 10) : "",
                    l.project_name || "",
                    l.project_module_name || "",
                    l.issue_key || "",
                    l.issue_type_name || "",
                    l.comment || "",
                    l.log_time || "",
                    l.timeSpent || ""
                ];
                worksheet.addRow(excelRow);
                if (lastUser === null) {
                    lastUser = l.user_display_name;
                    lastUserStartRow = dataStartRow + i;
                } else if (l.user_display_name !== lastUser) {
                    if (dataStartRow + i - lastUserStartRow > 1) {
                        worksheet.mergeCells(`A${lastUserStartRow}:A${dataStartRow + i - 1}`);
                        worksheet.getCell(`A${lastUserStartRow}`).alignment = { vertical: "middle", horizontal: "center" };
                        worksheet.getCell(`A${lastUserStartRow}`).font = { bold: true };
                    }
                    lastUser = l.user_display_name;
                    lastUserStartRow = dataStartRow + i;
                }
            });
            const totalRows = worksheet.lastRow.number;
            if (totalRows - lastUserStartRow >= 1) {
                worksheet.mergeCells(`A${lastUserStartRow}:A${totalRows}`);
                worksheet.getCell(`A${lastUserStartRow}`).alignment = { vertical: "middle", horizontal: "center" };
                worksheet.getCell(`A${lastUserStartRow}`).font = { bold: true };
            }
            for (let r = dataStartRow; r <= worksheet.lastRow.number; ++r) {
                worksheet.getCell(r, 7).alignment = { wrapText: true, vertical: "top" };
            }
            worksheet.getRow(1).eachCell(cell => {
                cell.font = { bold: true };
                cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
            });
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, `Employee_timesheet_${start}_to_${end}.xlsx`);
        } catch (error) {
            console.error("error::", error);
        }
    };

    return useMemo(() => ({
        columnDefs, upsertPendingTimesheet, visible, setVisible, handleMonthChange, getExcelDownload, onCellClicked, handleDateChange, timeSheetOpen, setTimeSheetOpen, columns, tagRef, timesheetOptions, loader, rowDatas, pinnedBottomRowData, excelLoader, getManagerExcelDownload, setManagerTimesheetData, handleDownloadTimeSheet, getAllEmployeeTimesheetExcel, filterValues, setFilterValues, detailsPopup, setDetailsPopup
    }), [columnDefs, upsertPendingTimesheet, visible, setVisible, handleMonthChange, getExcelDownload, onCellClicked, handleDateChange, timeSheetOpen, setTimeSheetOpen, columns, tagRef, timesheetOptions, loader, rowDatas, pinnedBottomRowData, excelLoader, getManagerExcelDownload, setManagerTimesheetData, handleDownloadTimeSheet, getAllEmployeeTimesheetExcel, filterValues, setFilterValues, detailsPopup, setDetailsPopup])
}